var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorsport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#505050",
    fillRule: "nonzero",
    points: "0 0 30 0 30 30 0 30",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFB",
    fillRule: "nonzero",
    d: "m18.85 2.568 6.86 12.64c-4.04.698-6.597 1.264-7.673 1.698-.484.254 1.26 1.655.908 2.033l-.02.018c-.96 1.934-11.279 6.51-12.081 8.616l-1.879-3.215c-.71-1.303-2.238-4.144-4.583-8.522.777-2.053 2.559-4.494 8.85-7.192-3.805-6.254 7.67-5.65 9.617-6.076l.001 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "m17.821 17.002.378-.034.844 1.189c.226.324.384.558.473.702l-.296.19-1.399-2.047 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m21.066 6.723 5.048 8.694-.385.1c-3.71.909-10.759.963-9.812 4.493-2.564-4.202-5.087-8.43-7.567-12.682-1.341-4.592 6.76-4.064 10.094-5l.21.376-3.817.632 2.291 4.09-.736.104c-1.576.232-3.01.522-3.83.934l-2.367-4.1c-1.629.729-2.061 1.87-1.195 3.457l1.832 3.13c.047-1.403.728-2.042 1.667-2.34l2.41 4.15c-1.034.564-1.751 1.317-1.491 2.654l2.074 3.565c.274-.939.823-1.606 1.799-1.97l-2.295-4.135c1.262-.746 2.921-.938 4.502-1.158l2.334 4.138 1.68-.27c.742-.125 1.462-.26 2.11-.436l-2.276-4.101-3.687.578-2.372-4.18 3.78-.723-.001 0Zm-15.632 9.531c1.293-1.063 2.746-1.915 4.306-2.523.869 1.363 1.623 2.812 2.384 4.226l-4.35 2.494-2.34-4.197 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M9.233 8.644c-4.846 1.614-8.23 4.263-9.233 7.238l7.23 13.02c3.195-7.705 14.543-6.872 12.228-10.134-.826-.34-1.794.746-2.702 1.239-.735.203-1.077-.407-1.418-1.114l-1.063-1.882-.758.32c-.497.215-.972.44-1.382.686l2.222 4.086c-1.84.777-3.19 1.525-4.322 2.342l-2.27-3.915c-1.315.827-2.21 1.847-2.783 3.43l-2.245-4.088c.389-1.419 1.413-2.588 2.67-3.678l-2.222-4.037c1.24-1.047 2.754-1.879 4.364-2.485l2.188 4.03 2.063-.816-2.567-4.242Zm8.671-7.273 11.614 20.511c.214.023.365-.088.482-.273l-11.615-20.509c-.238-.033-.414.034-.481.272l0-.001Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorsport);
export default __webpack_public_path__ + "static/media/motorsport.c760e445ebaec24e4513d7034209f288.svg";
export { ForwardRef as ReactComponent };